export default __webpack_public_path__ + "c35885ab3e272387ca91330dce5b3d28.svg";